import { useEffect, useState } from 'react';
import { ConfigService } from '../../services';
import HeaderUserInfo from './header-user-info.component';
import SubHeader from './subheader.component';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { UserFetch } from '../../features/user.feature';
import { Stack, Typography } from '@mui/material';

const Header = () => {
    const [headerHeight, setHeaderHeight] = useState<string | number>('auto');
    const [headerProps, setHeaderProps] = useState({
        width: '100%',
        title: 'Header',
        scrolling: 'auto',
        frameBorder: '0'
    });

    const dispatch = useAppDispatch();
    const currentUser = useAppSelector((state) => state.User.CurrentUser);
    const [isImpersonated, setIsImpersonated] = useState<boolean>(false);

    useEffect(() => {
        if (!currentUser) dispatch(UserFetch.GetCurrentUser());

        const user = sessionStorage.getItem('impersonatedUser');
        if (!user) return;
        setIsImpersonated(true);
    }, [currentUser, dispatch]);

    const dispatchMessage = (payload: any) => {
        const headerContent: any = document.getElementById('ifrmHeader');
        headerContent?.contentWindow?.postMessage(payload, '*');
    };

    const messageListener = (e: any) => {
        const event = e.data?.event;
        if (!event) return;

        switch (event) {
            case 'resizeheader':
                setHeaderHeight(e.data.height);
                break;
            case 'headerProps':
                if (e.data.props && typeof e.data.props === 'object') {
                    setHeaderProps((currentProps) => ({ ...currentProps, ...e.data.props }));
                }
                break;
            default:
                break;
        }
    };

    const clickListener = () => setHeaderHeight(70);
    const resizeListener = () => dispatchMessage({ windowResize: { width: window.innerWidth } });

    const triggerOnLoad = () => {
        const user = 'user';
        const host = window.location;
        const environment = 'https://dev-smapp.apps.eagle.org/';
        const copyright = `ABS &copy; ${new Date().getFullYear()} All Rights Reserved`;
        const buildTime = 'buildTime';
        const payLoad = { headerLoaded: true, copyright, buildTime, user, host, environment };
        dispatchMessage(JSON.parse(JSON.stringify(payLoad)));
    };

    useEffect(() => {
        window.addEventListener('message', messageListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('click', clickListener);

        return () => {
            window.removeEventListener('message', messageListener);
            window.removeEventListener('resize', resizeListener);
            window.removeEventListener('click', clickListener);
        };
    }, []);

    return (
        <>
            <div id="HeaderWrapper" style={{ height: '70px' }}>
                <iframe
                    src={ConfigService.appConfig.aemHeaderUrl}
                    id="ifrmHeader"
                    height={headerHeight}
                    onLoad={triggerOnLoad}
                    {...headerProps}
                    style={{ position: 'fixed', width: '100%', top: 0, left: 0, zIndex: 1042 }}
                />
            </div>

            <div style={{ position: 'fixed', height: '70px', top: 0, right: 0, zIndex: 1050, minWidth: '260px' }}>
                <HeaderUserInfo />
            </div>

            <SubHeader />

            {isImpersonated && currentUser && (
                <Stack direction={'row'} alignContent={'center'} justifyContent={'center'} alignItems={'center'} style={{ backgroundColor: '#DA1F33', color: '#ffffff', padding: 5 }} gap={2}>
                    <Typography>
                        Impersonating <b>{currentUser.UserName}</b>
                    </Typography>
                </Stack>
            )}
        </>
    );
};

export default Header;
